import { default as DataPreferences } from './DataPreferences';

export { DataPreferences };
